import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { BaseComponent } from '../../../base/base.component';
import { HttpService } from '../../../shared/services/http.service';

@Component({
  selector: 'app-employment-form',
  templateUrl: './employment-form.component.html',
  styleUrls: [
    './employment-form.component.scss',
    '../../../../assets/form.scss',
  ],
})
export class EmploymentFormComponent extends BaseComponent implements OnInit {
  header: string = 'فرم استخدام';

  days = [];
  months = [];
  years = [];

  jobTitle = '';

  military = undefined;
  exemption = undefined;

  licenses = [
    {
      value: 'اصول بازار سرمایه',
      selected: false,
    },
    {
      value: 'مدیریت نهادهای بازار سرمایه',
      selected: false,
    },
    {
      value: 'کارشناسی عرضه و پذیرش',
      selected: false,
    },
    {
      value: 'تحلیل گری بازار سرمایه',
      selected: false,
    },
    {
      value: ' ارزشیابی اوراق بهادار',
      selected: false,
    },
    {
      value: ' مدیریت سبد اوراق بهادار',
      selected: false,
    },
    {
      value: 'معامله گری بازار سرمایه',
      selected: false,
    },
  ];

  resumeArr = [
    {
      endDay: '',
      endMonth: '',
      endYear: '',
      jobTitle: '',
      startDay: '',
      startMonth: '',
      startYear: '',
      workfield: '',
      workplace: '',
      termination: '',
      consent: '',
    },
    {
      endDay: '',
      endMonth: '',
      endYear: '',
      jobTitle: '',
      startDay: '',
      startMonth: '',
      startYear: '',
      workfield: '',
      workplace: '',
      termination: '',
      consent: '',
    },
  ];

  constructor(
    private title: Title,
    private http: HttpService,
    private activatedRoute: ActivatedRoute
  ) {
    super();
    this.title.setTitle(`${this.header} | کارگزاری آبان`);
  }

  ngOnInit(): void {
    this.days = Array.from({ length: 31 }, (_, i) => i + 1);
    this.months = Array.from({ length: 12 }, (_, i) => i + 1);
    this.years = Array.from({ length: 57 }, (_, i) => i + 1345);
    super.ngOnInit();

    this.activatedRoute.queryParams
      .pipe(filter((params) => params.jobTitle))
      .subscribe((params) => {
        this.jobTitle = params.jobTitle;
      });
  }

  submit(form: NgForm) {
    if (form.invalid) {
      return;
    }

    const {
      lastname,
      englishFamiliar,
      resume,
      firstname,
      educationCity,
      nationalCode,
      graduationDay,
      graduationMonth,
      graduationYear,
      mobile,
      email,
      subject,
      militaryStatus,
      city,
      address,
      education,
      field,
      callageName,
      exemptionType,
      description,
      mariageStatus,
      gender,
      birthday,
      birthmonth,
      birthyear,
      birthLocation,
      otherCourses,
    } = form.value;
    const _subject = `${this.jobTitle}: ${form.value.firstname} ${form.value.lastname}`;
    const body = `<p style=""direction: rtl;"">
    نام و نام خانوادگی: ${firstname} ${lastname} </p><p style=""direction: rtl;"">
    کد ملی: ${nationalCode}
    </p><p style=""direction: rtl;"">
    تلفن همراه: ${mobile}
    </p><p style=""direction: rtl;"">
    آدرس ایمیل: ${email}
    </p><p style=""direction: rtl;"">
    جنسیت: ${gender}
    </p><p style=""direction: rtl;"">
    </p>
    <p style=""direction: rtl;"">
    تاریخ تولد: ${birthday}/${birthmonth}/${birthyear}
    </p>
    <p style=""direction: rtl;"">
    محل تولد: ${birthLocation}
    </p>
    <p style=""direction: rtl;"">
    وضعیت تاهل: ${mariageStatus}
    </p>
    <p style=""direction: rtl;"">
    وضعیت نظام وظیفه: ${militaryStatus}
    </p>
    <p style=""direction: rtl;"">
    نوع معافیت: ${exemptionType}
    </p>
    <p style=""direction: rtl;"">
    شهر محل سکونت : ${city}
    </p>
    <p style=""direction: rtl;"">
    محله محل سکونت: ${address}
    </p>
    <p style=""direction: rtl;"">
     رشته تحصیلی : ${field}
    </p>
    <p style=""direction: rtl;"">
    آخرین مدرک تحصیلی : ${education}
    </p>
    <p style=""direction: rtl;"">
    نام موسسه آموزشی : ${callageName}
    </p>
    <p style=""direction: rtl;"">
    شهر محل تحصیل : ${educationCity}
    </p>
    <p style=""direction: rtl;"">
    تاریخ فراغت از تحصیل : ${graduationYear}/${graduationMonth}/${graduationDay}
    </p>
    <p style=""direction: rtl;"">
    گواهینامه های بورسی : ${this.licenses
      .filter((f) => f.selected)
      .map((m) => m.value)
      .join(', ')}
    </p>
    <p style=""direction: rtl;"">
    سایر دوره ها : ${otherCourses}
    </p>
    <p style=""direction: rtl;"">
    آشنایی با زبان انگلیسی : ${englishFamiliar}
    </p>
    <p style=""direction: rtl;"">
    سوابق کاری: ${resume}
    </p>
    <p style=""direction: rtl;"">
    ${this.resumeArr.map((item, i) => {
      const result = `
        <span>محل کار شماره : </span> ${i}</br>
        <span>نام محل کار : </span> ${item.workplace}</br>
        <span>زمینه فعالیت : </span> ${item.workfield}</br>
        <span>عنوان شغلی : </span> ${item.jobTitle}</br>
        <span>تاریخ شروع به کار : </span> ${item.startYear}/${item.startMonth}/${item.startDay}</br>
        <span>تاریخ خاتمه به کار : </span> ${item.endYear}/${item.endMonth}/${item.endDay}</br>
        <span>علت خاتمه به کار: </span> ${item.termination}</br>
        <span>رضایت نامه: </span> ${item.consent}</br>
      
        </br>
      `;
      return result;
    })}
    </p>
    <p style=""direction: rtl;"">
    توضیحات: ${description}
    </p>`;

    const formData = new FormData();
    formData.append('From', email);
    formData.append('Subject', _subject);
    formData.append('UserName', firstname + ' ' + lastname);
    formData.append('Body', body);

    this.http.post('https://app.aban.net/MailHR.php', formData);
  }
}
